import React, { useState } from 'react'
import { ModalWrapper, SelectField, StyledButton, TextFields } from '../../../../../../components'
import { useGlobal, usePostApi } from '../../../../../../shared'
import { urls } from '../../../../../../shared/config'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import { setClassSteps, setLoader, setRefreshPage } from '../../../../../../redux/globalSlice'
import {
  Box,
  Checkbox,
  Select,
  Input,
  MenuItem,
  ListItemText,
  Chip,
  Typography,
  FormControlLabel,
} from '@mui/material'
import { InfoField } from '../../School/PopOver/SchoolInfo'
import { highestInt } from '../../../../../../shared/utils/constants'
import SchoolDetails from '../../../../../../common/SchoolDetails/SchoolDetails'
import { Buttons } from '../../School/SchoolRegistration/components/Steps'
import classes from './AddClass.module.css'
import { SuccesAnimation } from '../../../../../../assets/images'
import StudentBox from '../../../../../../common/StudentBox/StudentBox'
const monthOptions = [
  { label: 'January', value: 'January' },
  { label: 'February', value: 'February' },
  { label: 'March', value: 'March' },
  { label: 'April', value: 'April' },
  { label: 'May', value: 'May' },
  { label: 'June', value: 'June' },
  { label: 'July', value: 'July' },
  { label: 'August', value: 'August' },
  { label: 'September', value: 'September' },
  { label: 'October', value: 'October' },
  { label: 'November', value: 'November' },
  { label: 'December', value: 'December' },
]
export const AddClass = ({ open, handleClose, customRole, userSchoolId,refetch }) => {
  const { postApi } = usePostApi()
  const dispatch = useDispatch()
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  const SchoolDInfo = useSelector((state) => state.global.SchoolDInfo)
  const isEdit = useSelector((state) => state.global.isEdit)

  const step = useSelector((state) => state.global.classSteps)

  // console.log('---SchoolDInfo', SchoolDInfo)

  // const [step, setStep] = useState(3)

  const maxSteps = 3

  const { data: gradeList } = useGlobal({ userUrl: urls.ALL_GRADES })
  const { data: sectionList } = useGlobal({ userUrl: urls.ALL_SECTION })
  const { data: subjectList, count: subjectCount } = useGlobal({
    userUrl: `${urls.SUBJECT}?page=1&limit=100&school_id=${userSchoolId}`,
  })
  const [successData, setSuccessData] = useState({
    grade: '',
    section: '',
  })

  const [selectedSections, setSelectedSections] = useState([])
  const [anchorEl, setAnchorEl] = useState(null)

  const mocksubjects = ['Hindi', 'English', 'Maths']

  const initialValues = {
    schoolName: '',
    gradeName: isEdit ? SchoolDInfo?.grade_id : '',
    tuition_fee: isEdit ? SchoolDInfo?.tuition_fee : 0,
    exam_fee: isEdit ? SchoolDInfo?.exam_fee : 0,
    subject: isEdit ? SchoolDInfo?.grade_subjects : [],
    start_month: isEdit ? SchoolDInfo?.grade_start_month : '',
  }

  const handleSuccess = () => {
    if (step === 3) {
      handleClose()
      dispatch(setClassSteps(1))
    } else {
      return
    }
  }
  const handleInputChange = (fieldName) => (e) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, '')
    formik.setFieldValue(fieldName, numericValue)
  }

  const validationSchema = Yup.object({
    gradeName: Yup.string().required('Grade Name is required'),
    tuition_fee: Yup.string().required('Tuition Fee is required'),
    exam_fee: Yup.string().required('Exam Fee is required'),
    start_month: Yup.string().required('Start Month is required'),
    subject: Yup.array()
      .of(Yup.string()) // or Yup.number() depending on your id type
      .min(1, 'At least one subject is required')
      .required('Subject is required'),
  })

  const handleSubmit = () => {
    dispatch(setLoader(true))
    validationSchema
      .validate(formik.values, { abortEarly: false })
      .then(async () => {
        if (selectedSections?.length == 0) {
          toast.error('Section is required')
          dispatch(setLoader(false))
          return
        }
        if (customRole != 'Admin') {
          if (!formik.values.schoolName) {
            toast.error('School is required')
            dispatch(setLoader(false))
            return
          }
        }
        const responseBody = {
          school_id: customRole == 'Admin' ? userSchoolId : formik.values.schoolName,
          grade_id: formik.values.gradeName,
          tuition_fee: formik.values.tuition_fee,
          exam_fee: formik.values.exam_fee,
          section_id: selectedSections,
          subjects: formik.values.subject,
        }
        postApi(urls.GRADE_POST, responseBody)
          .then((response) => {
            if (response.status == 201 || response.status == 200) {
              toast.success('Class Added Successfully!')
              dispatch(setLoader(false))

              dispatch(setClassSteps(3))
              refetch()
              // handleClose()
              // dispatch(setRefreshPage(true))
            } else {
              if (response.message) {
                toast.error(response.message)
                refetch()
              } else {
                toast.error(response.error.message)
                refetch()
              }
              toast.error(response.error.message)
              dispatch(setLoader(false))
              refetch()
            }
          })
          .catch((error) => {
            toast.error(error)
            dispatch(setLoader(false))
            refetch()
          })
      })
      .catch((error) => {
        if (error instanceof Yup.ValidationError) {
          error.inner.forEach((err) => {
            toast.error(err.message)
          })
        }
        dispatch(setLoader(false))
      })
  }

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  })

  const handlePopperOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopperClose = () => {
    setAnchorEl(null)
  }

  const MenuProps = {
    anchorEl,
    open: Boolean(anchorEl),
    onClose: handlePopperClose,
    anchorOrigin: {
      vertical: 'left',
      horizontal: 'left',
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
  }
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name
  const userSchoolDetails = schoolList?.find((school) => school.school_id == userSchoolId)
  // console.log('----userSchoolDetails', userSchoolDetails)

  const handleNext = () => {
    // Optional: Add validation per step if needed
    if (step === 1) {
      // Step 1: Grade selection
      if (!formik.values.gradeName) {
        toast.error('Please select a grade/class name')
        return
      } else if (selectedSections.length === 0) {
        toast.error('Please select at least one section')
        return
      }
    }

    // If we reach here → can go next
    if (step < maxSteps) {
      dispatch(setClassSteps(step + 1))
    }
  }

  const handlePrev = () => {
    if (step > 1) {
      dispatch(setClassSteps(step - 1))
    } else {
      handleClose()
    }
  }

  return (
    <ModalWrapper
      open={open}
      handleClose={handleClose}
      width={'500px'}
      title={step == 3 ? '' : 'Add Class'}
    >
      {step == 3 ? (
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            alignItems: 'center',
          }}
        >
          <img
            src={SuccesAnimation}
            alt=""
            srcSet=""
            style={{
              width: '100px',
              height: '100px',
            }}
          />
          <p className={classes.title}>{'New Class Recorded'}</p>
          {/* <div className="student-detail-box">
            <StudentBox grade student_name={`${successData?.grade} ${successData?.section}`} />
          </div> */}
          <StyledButton modal onClick={handleSuccess}>
            Okay
          </StyledButton>
        </div>
      ) : (
        <div>
          {/* {customRole == 'Admin' ? (
          <InfoField label={'School'} value={userSchoolName} width={'100%'} />
        ) : (
          <SelectField
            label={'School'}
            options={(schoolList || []).map((prod) => ({
              value: prod.school_id,
              label: prod.school_name,
            }))}
            required
            width={'100%'}
            name="schoolName"
            value={formik.values.schoolName}
            onChange={(selectedOption) => formik.setFieldValue('schoolName', selectedOption)}
          />
        )} */}
          <SchoolDetails
            schoolName={userSchoolName}
            avatar={userSchoolDetails?.school_avatar}
            margin={'0px 0px 24px 0px'}
          />
          {step === 1 && (
            <>
              {' '}
              <SelectField
                label={'Assign Class Name'}
                options={(gradeList || []).map((prod) => ({
                  value: prod.grade_id,
                  label: prod.grade,
                }))}
                required
                width={'100%'}
                name="gradeName"
                value={formik.values.gradeName}
                subLabel={'Grade :'}
                onChange={(selectedOption) => formik.setFieldValue('gradeName', selectedOption)}
              />
              <Box mt={2} mb={3}>
                {/* <Typography mb={2} className="custom-selectfield-label">
            Sections<span className="req">*</span>
          </Typography> */}
                <Select
                  multiple
                  value={selectedSections}
                  onChange={(e) => setSelectedSections(e.target.value)}
                  input={<Input />}
                  variant="outlined"
                  sx={{ width: '100%', borderRadius: '50%' }}
                  renderValue={(selected) => (
                    <div style={{ display: 'flex', gap: '5px' }}>
                      {selected.length > 0 ? (
                        selected.map((value) => {
                          const section = sectionList.find((option) => option.section_id === value)
                          return (
                            <Chip
                              className="sections-box"
                              key={value}
                              label={section ? section.section : ''}
                            />
                          )
                        })
                      ) : (
                        <Typography className="">Select</Typography>
                      )}
                    </div>
                  )}
                  MenuProps={MenuProps}
                  onOpen={handlePopperOpen}
                  onClose={handlePopperClose}
                  displayEmpty
                >
                  {sectionList?.map((option) => (
                    <MenuItem key={option.section_id} value={option.section_id}>
                      <Checkbox checked={selectedSections.indexOf(option.section_id) > -1} />
                      <ListItemText primary={option.section} />
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              <div
                // style={{
                //   flexDirection: 'column',
                //   gap: '0px',
                // }}
                className="text-fields"
              >
                <TextFields
                  label={'Tuition Fee'}
                  width={'100%'}
                  required
                  name={'tuition_fee'}
                  placeholder={'Enter Tuition Fee'}
                  value={formik.values.tuition_fee}
                  onChange={handleInputChange('tuition_fee')}
                />
                <TextFields
                  label={'Exam Fee'}
                  width={'100%'}
                  required
                  placeholder={'Enter Exam Fee'}
                  name={'exam_fee'}
                  value={formik.values.exam_fee}
                  onChange={handleInputChange('exam_fee')}
                />
              </div>
              {/* <TextFields
                label={'Start Month'}
                width={'100%'}
                required
                placeholder={'Enter Start Month'}
                name={'start_month'}
                value={formik.values.start_month}
                onChange={handleInputChange('start_month')}
              /> */}
              <SelectField
                label="Start Month"
                required
                options={monthOptions.map((month) => ({
                  value: month.value, // 'January', 'February', ...
                  label: month.label,
                }))}
                width="100%"
                name="start_month"
                value={formik.values.start_month || ''} // safe access
                onChange={(selected) => {
                  // Most SelectField components pass either:
                  // A) the value directly (string)
                  // B) an object { value, label }

                  const newValue = selected?.value ?? selected // handle both patterns
                  formik.setFieldValue('start_month', newValue)
                }}
                placeholder="Select start month"
                // Optional: show error if you have formik touched + errors setup
                // error={formik.touched.start_month && Boolean(formik.errors.start_month)}
                // helperText={formik.touched.start_month && formik.errors.start_month}
              />
            </>
          )}
          {step === 2 && (
            <>
              <Typography mb={1.25} className="custom-selectfield-label">
                Subjects<span className="req">*</span>
              </Typography>
              <div className={classes.box}>
                {subjectList?.map((subj, index) => {
                  const isChecked = formik.values.subject.includes(subj.subject_id)
                  const isLastItem = index === subjectList?.length - 1

                  return (
                    <div
                      key={index}
                      style={{
                        borderBottom: isLastItem ? 'none' : '',
                      }}
                      className={classes.subjrxt}
                    >
                      <FormControlLabel
                        key={subj.subject_id}
                        control={
                          <Checkbox
                            checked={isChecked}
                            onChange={() => {
                              if (isChecked) {
                                // remove
                                formik.setFieldValue(
                                  'subject',
                                  formik.values.subject.filter((id) => id !== subj.subject_id),
                                )
                              } else {
                                // add
                                formik.setFieldValue('subject', [
                                  ...formik.values.subject,
                                  subj.subject_id,
                                ])
                              }
                            }}
                            name="subject"
                            value={subj.subject_id}
                          />
                        }
                        label={subj.subject_name}
                        labelPlacement="end"
                      />
                    </div>
                  )
                })}
              </div>
            </>
          )}

          <Buttons
            onNext={step === 2 ? handleSubmit : handleNext}
            text={'Back'}
            onPrev={handlePrev}
          ></Buttons>
          {/* <StyledButton onClick={handleSubmit}>Submit</StyledButton> */}
        </div>
      )}
    </ModalWrapper>
  )
}
